import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';

const styles = {
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0',
    width: 107
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  userImage: {
    width: '100px',
    height: '100px'
  }
};

const enhance = compose(pure);

const ShopTable = enhance(({ classes, detail }) => {
  return (
    <Table className={classes.detailTable}>
      <TableRow>
        <TableCell className={classes.tableCellItem}>アカウントID</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.accountId}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>名前</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.displayName}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>メールアドレス</TableCell>
        <TableCell className={classes.tableCellData}>{detail.email}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>CognitoユーザID</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.cognitoUserId}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>ステータス</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.statusStr}
        </TableCell>
      </TableRow>
      {/* <TableRow>
        <TableCell className={classes.tableCellItem}>Stripe会員ID</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.stripeCustomerId}
        </TableCell>
      </TableRow> */}
      <TableRow>
        <TableCell className={classes.tableCellItem}>自己紹介</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.message}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>登録日時</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.createdAt}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>更新日時</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.updatedAt}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>画像</TableCell>
        <TableCell className={classes.tableCellData}>
          <Card className={classes.userImage}>
            <CardActionArea>
              <CardMedia component="img" image={detail.image} />
            </CardActionArea>
          </Card>
        </TableCell>
      </TableRow>
    </Table>
  );
});

export default withStyles(styles)(ShopTable);
